export const contentTypeMultipart = {
	headers: {
		"content-type": "multipart/form-data",
	},
};
